import { FC } from 'react';
import { useToltAffiliate } from '../helpers/external-tools-helper';

/**
 * Tolt Affiliate Tracking Component
 * Conditionally loads Tolt script when affiliate parameters are present in URL
 */
const ToltAffiliate: FC = () => {
  const { isLoaded } = useToltAffiliate();

  // This component doesn't render anything visible
  // It just handles the conditional script loading
  return null;
};

export default ToltAffiliate;
